/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCloudflareRulesetEngine = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.5 3l.5-.5h7.5v1h-7v10h8v1H2l-.5-.5V3zM8 5.75H3.5v-1H8v1zm.5 2h-5v-1h5v1zm-1.5 2H3.5v-1H7v1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.873 3.256a2.74 2.74 0 0 0-1.287 2.253 2.74 2.74 0 0 0 1.8 2.643l.329.47.001 5.378h1.213l.001-5.378.329-.47a2.74 2.74 0 0 0 1.8-2.643 2.74 2.74 0 0 0-.556-1.585c-.202-.267-.45-.492-.731-.667l-.001 2.133-.5.5h-1.897l-.5-.5-.001-2.133zm-1.528.063a3.74 3.74 0 0 1 1.88-1.313l.647.478.001 2.405h.898l.001-2.405.647-.478a3.74 3.74 0 0 1 2.64 3.478 3.74 3.74 0 0 1-2.129 3.471l-.001 5.546-.5.5h-2.213l-.5-.5-.001-5.546a3.74 3.74 0 0 1-2.129-3.471 3.74 3.74 0 0 1 .759-2.164z"
}));

export default SvgCloudflareRulesetEngine;